import React from "react";
import { useNavigate } from "react-router-dom";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Box, Typography, Button, Container } from "@mui/material";

export default function ErrorPage() {
  const navigate = useNavigate();
  const { logout } = useKindeAuth();

  const handleLogout = () => {
    logout();
  };

  const handleHome = () => {
    navigate("/");
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          textAlign: "center",
          gap: 2,
        }}
      >
        <Typography variant="h3" color="error" gutterBottom>
          Oops!
        </Typography>
        <Typography variant="h6" color="textSecondary" gutterBottom>
          Something went wrong. Your session may have expired.
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Please try logging in again.
        </Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button variant="contained" onClick={handleHome}>
            Go Home
          </Button>
          <Button variant="outlined" onClick={handleLogout}>
            Log Out
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
